import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Locale from 'browser-locale';

import Transforms from './Transforms';

import Text from './Text';
import Layers from './Layers';
import Pictures from './Pictures';
import Basket from './Basket';
import TopToolBar from './TopToolBar';
import CutCopyClone from './CutCopyClone';
import CopyLayersMessage from './CopyLayersMessage';
import StartSite from './StartSite';
import Notify from './Notify';
import SocialGraphic from './SocialGraphic';
import Crop from './Crop';
import bfLayers from './bfLayers';
import CanvaTool from './CanvaTool';
import Toolbar from './Toolbar';
import UploadInfo from './UploadInfo';
import ls from 'local-storage';
import Dictionary from './Dictionary';
import Settings from './Settings';

window.bfLayers = bfLayers;

let ccc = new CutCopyClone();

import BFSingleProject from './single-project';


let bf_project = new BFSingleProject();
window.bf_project = bf_project;


if ( bf_config.mode != 'phantom') {

  let dictionaryStorage = new Dictionary(bf_config);
  let lang = Locale().substring(0, 2);

  if ( bf_config.currentLang == '' || bf_config.currentLang == undefined ) bf_config.currentLang = lang;
  ls.set('lang',bf_config.currentLang);
  //try { if ( ls.get('lang') ) bf_config.currentLang = ls.get('lang'); } catch(e) {}

  if ( $('.StartSiteIndex').length > 0 )
  {
      dictionaryStorage.switchLang(bf_config.currentLang);

      ReactDOM.render(<StartSite  popup={false} dictionaryStorage={dictionaryStorage}/>, document.getElementById('StartSite'));


   // ReactDOM.render(<StartSite dictionaryStorage={dictionaryStorage}/>, document.getElementById('StartSite'));
    //ReactDOM.render(<LangSwitcher startLang={bf_config.currentLang} dictionaryStorage={dictionaryStorage}/>, document.getElementById('LangSwitcher'));
  }
  else
  {

    dictionaryStorage.switchLang(bf_config.currentLang);
    //ReactDOM.render(<LangSwitcher startLang={bf_config.currentLang} dictionaryStorage={dictionaryStorage}/>, document.getElementById('LangSwitcher'));

    ReactDOM.render(<TopToolBar config={bf_config} dictionaryStorage={dictionaryStorage}/>,  document.getElementById('bf-tools-area-header'));
    ReactDOM.render(<Transforms dictionaryStorage={dictionaryStorage}/>, document.getElementById('Transforms'));

    ReactDOM.render(<Crop dictionaryStorage={dictionaryStorage}/>, document.getElementById('Crop'));

    if ( $('#Adjustment').length > 0 )
    {
    //ReactDOM.render(<Adjustment dictionaryStorage={dictionaryStorage}/>, document.getElementById('Adjustment'));
    //  ReactDOM.render(<AdjustmentContainer dictionaryStorage={dictionaryStorage}><Adjustment dictionaryStorage={dictionaryStorage}/></AdjustmentContainer>, document.getElementById('Adjustment'));
    }

    if ( $('#SnapToElement').length > 0 )
    {
     // ReactDOM.render(<SnapToElement checked={true} dictionaryStorage={dictionaryStorage}/>, document.getElementById('SnapToElement'));
    }

    if ( $('#Text').length > 0 )
    {
      ReactDOM.render(<Text dictionaryStorage={dictionaryStorage}/>, document.getElementById('Text'));
    }

    if ( $('#BackgroundColor').length > 0 )
    {
    //  ReactDOM.render(<BackgroundColor dictionaryStorage={dictionaryStorage}/>, document.getElementById('BackgroundColor'))
    }

    if ( $('#CanvaTool').length > 0 )
    {
      ReactDOM.render(<CanvaTool dictionaryStorage={dictionaryStorage}/>, document.getElementById('CanvaTool'))
    }

    if ( $('#Toolbar').length > 0 )
    {
      ReactDOM.render(<Toolbar dictionaryStorage={dictionaryStorage}/>, document.getElementById('Toolbar'))
    }

    if ( $('#SocialGraphic').length > 0 )
    {
      ReactDOM.render(<SocialGraphic dictionaryStorage={dictionaryStorage}/>, document.getElementById('SocialGraphic'))
    }

    ReactDOM.render(<Pictures dictionaryStorage={dictionaryStorage}/>, document.getElementById('Pictures'));
    ReactDOM.render(<Basket config={bf_config} mobiVersion={true} dictionaryStorage={dictionaryStorage}/>,  document.getElementById('Basket'));

    ReactDOM.render(<Layers dictionaryStorage={dictionaryStorage}/>, document.getElementById('Layers'));
    ReactDOM.render(<CopyLayersMessage dictionaryStorage={dictionaryStorage}/>, document.getElementById('CopyLayersMessage'));
    ReactDOM.render(<Notify dictionaryStorage={dictionaryStorage}/>, document.getElementById('Notify'));
    ReactDOM.render(<UploadInfo dictionaryStorage={dictionaryStorage}/>, document.getElementById('UploadInfo'));

    if ( $('.StartSiteCreator').length > 0 ) {
      ReactDOM.render(<StartSite popup={true}
                                 dictionaryStorage={dictionaryStorage}/>, document.getElementById('StartSite'));
    }

  }
}


